import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { MarkMounted } from "./components/MarkMounted";
import "../public_html/assets/css/styles.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Beautify Ourselves root element was not found.");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <MarkMounted />
        <App />
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>
);
